import { render, staticRenderFns } from "./AssetsTransfer.vue?vue&type=template&id=2775567d"
import script from "./AssetsTransfer.vue?vue&type=script&lang=js"
export * from "./AssetsTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports